const kamulah = [
  {
    normal: [
      `<b style="font-weight: 900;"><i>Fresh graduate</i></b> dan <b style="font-weight: 900;">profesional pemula</b> dari berbagai jurusan, terutama MIPA, Teknik dan Jurusan terkait`
    ]
  },
  {
    normal: [
      `Siap kerja <b style="font-weight: 900;"><i>full-time</i></b> dan peduli dengan <b style="font-weight: 900;">perkembangan kepercayaan diri murid</b>`
    ]
  },
  {
    normal: [
      `Punya <b style="font-weight: 900;">pengalaman mengajar Matematika minimal 1 tahun</b> (baik formal maupun informal)`
    ]
  }
];
export default kamulah;
